function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useRef, useMemo, useState } from 'react';
import { getZIndex, useElementSize, getWindowSize, useRefCallback } from '@okee-uikit/react-hooks';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { createClamp } from '@okee-uikit/react-utils';
import { Close, Frame, Left, OneToOne, Right, Rotate, ZoomIn, ZoomOut } from '../../common/icons';
import { useDrag } from '../../hooks/drag';
import { Tooltip } from '../tooltip';
import { usePreloadImages } from './hooks';
var baseImgInfo = {
  top: 0,
  left: 0,
  scaleNum: 1,
  rotateDeg: 0,
  originTop: 0,
  originLeft: 0,
  isFull: false
};
var CONTAINER_PADDING = {
  width: 104,
  height: 48
};
var MAXIMUM_SCALE_NUM = 5;

var getInitialScale = function getInitialScale(image, clamp) {
  if (!image) {
    return 1;
  }

  var _getWindowSize = getWindowSize(),
      width = _getWindowSize.width,
      height = _getWindowSize.height;

  var wRatio = (width - CONTAINER_PADDING.width * 2) / image.width;
  var hRatio = (height - CONTAINER_PADDING.height * 2) / image.height;
  var ratio = Math.min.apply(null, [wRatio, hRatio]);
  return ratio < 1 ? clamp(ratio) : 1;
};

export var ImageView = function ImageView(props) {
  var _props$images = props.images,
      images = _props$images === void 0 ? [] : _props$images,
      handleClose = props.handleClose,
      maskStyle = props.maskStyle,
      _props$defaultActiveI = props.defaultActiveIndex,
      defaultActiveIndex = _props$defaultActiveI === void 0 ? 0 : _props$defaultActiveI,
      _props$scaleRatio = props.scaleRatio,
      scaleRatio = _props$scaleRatio === void 0 ? 0.25 : _props$scaleRatio,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? false : _props$maskClosable;
  var zIndex = useMemo(function () {
    return getZIndex();
  }, []);
  var imageViewRef = useRef(null);
  var imgRef = useRef(null);

  var _useState = useState(defaultActiveIndex),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(baseImgInfo),
      _useState4 = _slicedToArray(_useState3, 2),
      imgInfo = _useState4[0],
      setImgInfo = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      originalRatioMode = _useState6[0],
      setOriginalRatioMode = _useState6[1];

  var clamp = useCallback(createClamp(scaleRatio, MAXIMUM_SCALE_NUM), [scaleRatio]);
  var onImageActivate = useRefCallback(function (image) {
    setImgInfo(_objectSpread(_objectSpread({}, imgInfo), {}, {
      scaleNum: getInitialScale(image, clamp)
    }));
  });

  var _usePreloadImages = usePreloadImages({
    images: images,
    activeIndex: active,
    onImageActivate: onImageActivate
  }),
      currentImage = _usePreloadImages.currentImage;

  var loaded = currentImage.loaded;

  var _useState7 = useState({
    width: 0,
    height: 0
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      imgSize = _useState8[0],
      setImgSize = _useState8[1];

  var _useState9 = useState({
    width: 0,
    height: 0
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      imageViewSize = _useState10[0],
      setImageViewSize = _useState10[1];

  var imageViewCls = usePrefixCls('image-view');
  var containerCls = usePrefixCls('image-view-container');
  var closeCls = usePrefixCls('image-view-close');
  var bottomCls = usePrefixCls('image-view-bottom');
  var bottomOperate = usePrefixCls('image-view-bottom-operate');
  var bottomOperateDivide = usePrefixCls('image-view-bottom-operate-divide');
  var bottomOperateNum = usePrefixCls('image-view-bottom-operate-num');
  var bottomOperateDisabled = usePrefixCls('image-view-bottom-operate-disabled');
  var nextText = useLocale('image-view.next');
  var prevText = useLocale('image-view.prev');
  var zoomInText = useLocale('image-view.zoom-in');
  var zoomOutText = useLocale('image-view.zoom-out');
  var zoomToOriginText = useLocale('image-view.zoom-to-origin');
  var zoomToFitText = useLocale('image-view.zoom-to-fit');
  var rotateText = useLocale('image-view.rotate');
  var disablePrev = active === 0;
  var disableNext = active + 1 === images.length;
  var disableZoomIn = imgInfo.scaleNum === MAXIMUM_SCALE_NUM;
  var disableZoomOut = imgInfo.scaleNum <= scaleRatio;
  var handleSwitch = useCallback(function (index) {
    if (index >= images.length || index < 0) {
      return;
    }

    setImgInfo(baseImgInfo);
    setOriginalRatioMode(false);
    setActive(index);
  }, [images]);
  var handleScale = useCallback(function (step) {
    var scaleNum = imgInfo.scaleNum + step;

    if (scaleNum > 0) {
      setImgInfo(_objectSpread(_objectSpread({}, imgInfo), {}, {
        top: 0,
        left: 0,
        scaleNum: clamp(scaleNum)
      }));
    }
  }, [clamp, imgInfo]);

  var resetScale = function resetScale() {
    setOriginalRatioMode(true);
    setImgInfo(_objectSpread(_objectSpread({}, imgInfo), {}, {
      top: 0,
      left: 0,
      scaleNum: 1
    }));
  };

  var fitToContainer = useCallback(function () {
    setOriginalRatioMode(false);
    setImgInfo(_objectSpread(_objectSpread({}, imgInfo), {}, {
      top: 0,
      left: 0,
      scaleNum: getInitialScale(currentImage, clamp)
    }));
  }, [currentImage, imgInfo]);

  var handleMaskClose = function handleMaskClose(e) {
    var element = e === null || e === void 0 ? void 0 : e.target;

    if (!maskClosable || element.tagName === 'IMG') {
      return;
    }

    handleClose();
  };

  var handleDragging = function handleDragging(e) {
    var currentMousePos = e.currentMousePos,
        startMousePos = e.startMousePos;
    var offsetX = currentMousePos.clientX - startMousePos.clientX;
    var offsetY = currentMousePos.clientY - startMousePos.clientY;
    var top = imgInfo.originTop + offsetY;
    var left = imgInfo.originLeft + offsetX;

    if (imageViewSize.height >= imgSize.height || Math.abs(top) >= Math.abs((imageViewSize.height - imgSize.height) / 2)) {
      top = imgInfo.top;
    }

    if (imageViewSize.width >= imgSize.width || Math.abs(left) >= Math.abs((imageViewSize.width - imgSize.width) / 2)) {
      left = imgInfo.left;
    }

    setImgInfo(_objectSpread(_objectSpread({}, imgInfo), {}, {
      top: top,
      left: left
    }));
  };

  var handleDragEnd = function handleDragEnd() {
    setImgInfo(_objectSpread(_objectSpread({}, imgInfo), {}, {
      originLeft: imgInfo.left,
      originTop: imgInfo.top
    }));
  };

  var handleRotate = function handleRotate() {
    setImgInfo(_objectSpread(_objectSpread({}, imgInfo), {}, {
      top: 0,
      left: 0,
      rotateDeg: imgInfo.rotateDeg + 90
    }));
  };

  var getImgStyle = function getImgStyle() {
    var rotateDeg = imgInfo.rotateDeg,
        scaleNum = imgInfo.scaleNum,
        left = imgInfo.left,
        top = imgInfo.top,
        isFull = imgInfo.isFull;
    var isOdd = rotateDeg / 90 % 2 !== 0;

    if (isFull) {
      return {
        maxWidth: isOdd ? '100vh' : '100vw',
        maxHeight: isOdd ? '100vw' : '100vh',
        transform: "rotate(".concat(rotateDeg, "deg)")
      };
    }

    return {
      top: top,
      left: left,
      transform: "rotate(".concat(rotateDeg, "deg) scale(").concat(scaleNum, ")")
    };
  };

  useElementSize(imageViewRef, function () {
    return true;
  }, function (size) {
    setImageViewSize(size);
  });
  useElementSize(imgRef, function () {
    return true;
  }, function (size) {
    setImgSize(size);
  });
  useDrag(imgRef, {
    onDragging: handleDragging,
    onDragEnd: handleDragEnd
  });
  return React.createElement("div", {
    ref: imageViewRef,
    className: imageViewCls,
    style: _objectSpread({
      zIndex: zIndex
    }, maskStyle),
    onClick: function onClick(e) {
      return handleMaskClose(e);
    }
  }, React.createElement("div", {
    className: containerCls
  }, loaded && React.createElement("img", {
    ref: imgRef,
    src: images[active].url,
    style: getImgStyle()
  })), React.createElement("div", {
    className: closeCls,
    onClick: function onClick(event) {
      event.stopPropagation();
      handleClose();
    }
  }, React.createElement(Close, null)), React.createElement("div", {
    className: bottomCls,
    onClick: function onClick(event) {
      event.stopPropagation();
    }
  }, React.createElement("div", {
    className: bottomOperate
  }, React.createElement(Tooltip, {
    placement: "top",
    content: disablePrev ? '' : prevText
  }, React.createElement(Left, {
    size: 24,
    onClick: function onClick() {
      return handleSwitch(active - 1);
    },
    className: disablePrev ? bottomOperateDisabled : ''
  })), React.createElement("span", {
    className: bottomOperateNum,
    style: {
      width: 36
    }
  }, active + 1, "/", images.length), React.createElement(Tooltip, {
    placement: "top",
    content: disableNext ? '' : nextText
  }, React.createElement(Right, {
    size: 24,
    onClick: function onClick() {
      return handleSwitch(active + 1);
    },
    className: disableNext ? bottomOperateDisabled : ''
  })), React.createElement("span", {
    className: bottomOperateDivide
  }), React.createElement(Tooltip, {
    placement: "top",
    content: disableZoomIn ? '' : zoomInText
  }, React.createElement(ZoomIn, {
    size: 20,
    onClick: function onClick() {
      return handleScale(scaleRatio);
    },
    className: disableZoomIn ? bottomOperateDisabled : ''
  })), React.createElement("span", {
    className: bottomOperateNum,
    style: {
      width: 36
    }
  }, "".concat((imgInfo.scaleNum * 100).toFixed(0), "%")), React.createElement(Tooltip, {
    placement: "top",
    content: disableZoomOut ? '' : zoomOutText
  }, React.createElement(ZoomOut, {
    size: 20,
    onClick: function onClick() {
      return handleScale(-scaleRatio);
    },
    className: disableZoomOut ? bottomOperateDisabled : ''
  })), originalRatioMode ? React.createElement(Tooltip, {
    placement: "top",
    content: zoomToFitText
  }, React.createElement(Frame, {
    size: 20,
    onClick: fitToContainer
  })) : React.createElement(Tooltip, {
    placement: "top",
    content: zoomToOriginText
  }, React.createElement(OneToOne, {
    size: 20,
    onClick: resetScale
  })), React.createElement("span", {
    className: bottomOperateDivide
  }), React.createElement(Tooltip, {
    placement: "top",
    content: rotateText
  }, React.createElement(Rotate, {
    size: 20,
    onClick: handleRotate
  })))));
};